import { provideRouter, Routes } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { HomeGuard } from './core/guard/home-guard';
import { ControllerComponent } from './modules/controller/controller.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { InviteMemberPublicComponent } from './shared/components/invite-member-public/invite-member-public.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path:'invite-member/:id',
    component:InviteMemberPublicComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [HomeGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'controllers',
        loadChildren: () => import('./modules/controller/controller.module').then((m) => m.ControllerModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

export const appConfig = {
  providers: [provideRouter(routes)],
};

export class AppRoutingModule {}
